export default "__VITE_ASSET__6eFmdslQ__"